import React from "react";

const Section16YouTubeAPI = () => (
  <>
    <h2>16. Use of YouTube API Services</h2>
    <ul>
      <li>
        <strong>Use of YouTube API Services:</strong> Our Service uses YouTube API Services to access and analyze publicly available YouTube data on behalf of users. By using our Service, you agree to be bound by the{" "}
        <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer">
          YouTube Terms of Service
        </a>.
      </li>
      <li>
        <strong>Google Privacy Policy:</strong> We comply with the{" "}
        <a href="http://www.google.com/policies/privacy" target="_blank" rel="noopener noreferrer">
          Google Privacy Policy
        </a>, which outlines how Google collects and handles your data when using its services.
      </li>
      <li>
        <strong>Revoking Access:</strong> You can revoke this application's access to your YouTube data at any time by visiting the Google security settings page at{" "}
        <a href="https://security.google.com/settings/security/permissions" target="_blank" rel="noopener noreferrer">
          https://security.google.com/settings/security/permissions
        </a>.
      </li>
      <li>
        <strong>Data Deletion Requests:</strong> If you wish to request deletion of any stored data associated with your YouTube account, please contact us at{" "}
        <a href="mailto:help@comparedly.com">help@comparedly.com</a>. We will review and honor all legitimate requests in accordance with our data retention policies and applicable legal obligations.
      </li>
    </ul>
  </>
);

export default Section16YouTubeAPI;
